// extracted by mini-css-extract-plugin
export default {"onPageErrorSection":"OnPageError_onPageErrorSection__f60f7"};